import React from "react";
import Banner from "../components/banner/banner";
import Layout from "../layouts"
import ListItem from "../components/list-item/list-item";
import { fullPrivacy } from "../utils/legals/fullPrivacyInformation";
import "../styles/pages/privacy-policy.scss";
import CustomMarkdown from "../utils/customMarkdown";

const FullPrivacy = () => {

    return (

        <Layout
            SEOTitle={"Full Privacy Policy - United Legal Assistance"}
            SEODescription={"Full Privacy Policy - United Legal Assistance"}
            footerDisclaimer={""}>

            <div className="privacy-policy-container">

                <div style={{ margin: "40px 0" }}>
                    <h1 className="main-title">Full Privacy Policy</h1>
                    <b />
                </div>

                {
                    fullPrivacy.length ? fullPrivacy.map((item, index) => {

                        return (
                            <div key={index}>
                                {
                                    item.title ? <h3 className="bold">{item.title}</h3> : ""

                                }
                                {
                                    item.description ? Array.isArray(item.description) ? item.description.map((itemText, index) => {

                                        return (
                                            <>
                                                <h3 style={{ fontSize: "18px", margin: "10px 0 0 0", fontWeight: "bold", color: "#666" }}>{itemText.subtitle}</h3>
                                                <CustomMarkdown style={{ margin: "5px 0" }} key={index}>{itemText.text}</CustomMarkdown>
                                            </>
                                        )
                                    }) : <CustomMarkdown style={{ margin: "10px 0px 0px 0px" }}>{item.description}</CustomMarkdown> : ""
                                }
                                {
                                    item.itemList ?
                                        <div style={{ paddingTop: "10px" }}>
                                            {
                                                item.itemList?.length ? item.itemList.map((listItem, index) => {

                                                    return (
                                                        <>
                                                            {listItem.title ? <ListItem text={listItem.title} key={index} /> : ""}
                                                            <CustomMarkdown style={{ margin: "0px" }}>{listItem.description}</CustomMarkdown>
                                                        </>
                                                    )
                                                }) : ""
                                            }

                                        </div>
                                        : ""
                                }
                            </div>
                        )
                    }) : ""
                }

            </div>
        </Layout>
    )
}

export default FullPrivacy;